import { render, staticRenderFns } from "./BehaviorItem.vue?vue&type=template&id=76399aa6&scoped=true&"
import script from "./BehaviorItem.vue?vue&type=script&lang=js&"
export * from "./BehaviorItem.vue?vue&type=script&lang=js&"
import style0 from "./BehaviorItem.vue?vue&type=style&index=0&id=76399aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76399aa6",
  null
  
)

export default component.exports